/* eslint-disable no-tabs */
import PropTypes from 'prop-types';
import { RATED_TABLE_ICONS_DEFAULT } from 'components/icons/constants';

const AvgPriceIcon = ({
    fill = RATED_TABLE_ICONS_DEFAULT.fill,
    width = RATED_TABLE_ICONS_DEFAULT.fullWidth
}) => {
    /** SVG viewBox measures ratio */
    const ratio = 70.867 / 141.732;
    const HEIGHT = width * ratio;

    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={width}
            height={HEIGHT}
            viewBox="0 0 141.732 70.867"
            enableBackground="new 0 0 141.732 70.867"
            xmlSpace="preserve"
        >
            <path
                fill={fill}
                d="M34.233,69.054c-6.674,0-12.948-2.6-17.668-7.318c-4.719-4.72-7.318-10.994-7.318-17.668
	s2.6-12.948,7.318-17.668c4.72-4.719,10.994-7.318,17.668-7.318s12.948,2.6,17.668,7.318c4.719,4.72,7.318,10.994,7.318,17.668
	s-2.6,12.948-7.318,17.668C47.182,66.454,40.907,69.054,34.233,69.054z M34.233,21.417c-12.489,0-22.65,10.161-22.65,22.65
	c0,12.488,10.161,22.649,22.65,22.649s22.649-10.161,22.649-22.649C56.883,31.578,46.723,21.417,34.233,21.417z"
            />
            <g>
                <path
                    fill={fill}
                    d="M37.028,56.341v-3.275c-1.881-0.031-3.826-0.615-4.962-1.426l0.778-2.174
		c1.167,0.779,2.854,1.396,4.669,1.396c2.303,0,3.859-1.329,3.859-3.179c0-1.783-1.265-2.886-3.665-3.858
		c-3.307-1.297-5.35-2.788-5.35-5.61c0-2.691,1.913-4.734,4.896-5.221v-3.275h2.01v3.146c1.946,0.064,3.275,0.584,4.217,1.135
		l-0.812,2.14c-0.681-0.39-2.01-1.103-4.086-1.103c-2.496,0-3.437,1.492-3.437,2.789c0,1.687,1.199,2.529,4.021,3.697
		c3.341,1.361,5.026,3.048,5.026,5.934c0,2.563-1.783,4.962-5.124,5.513v3.372H37.028z"
                />
            </g>
            <g>
                <path
                    fill={fill}
                    d="M20.096,44.72c-0.174,0-0.316-0.057-0.429-0.169s-0.169-0.255-0.169-0.429v-0.985
		c0-0.173,0.057-0.315,0.169-0.428s0.255-0.169,0.429-0.169h7.783c0.189,0,0.337,0.057,0.44,0.169s0.156,0.255,0.156,0.428v0.985
		c0,0.174-0.053,0.316-0.156,0.429s-0.251,0.169-0.44,0.169H20.096z"
                />
            </g>
            <path
                fill={fill}
                d="M110.239,69.054c-6.674,0-12.948-2.6-17.668-7.318c-4.719-4.72-7.318-10.994-7.318-17.668
	s2.6-12.948,7.318-17.668c4.72-4.719,10.994-7.318,17.668-7.318s12.948,2.6,17.668,7.318c4.719,4.72,7.318,10.994,7.318,17.668
	s-2.6,12.948-7.318,17.668C123.188,66.454,116.913,69.054,110.239,69.054z M110.239,21.417c-12.489,0-22.65,10.161-22.65,22.65
	c0,12.488,10.161,22.649,22.65,22.649s22.649-10.161,22.649-22.649C132.889,31.578,122.729,21.417,110.239,21.417z"
            />
            <g>
                <path
                    fill={fill}
                    d="M115.01,56.341v-3.275c-1.881-0.031-3.827-0.615-4.962-1.426l0.778-2.174
		c1.168,0.779,2.854,1.396,4.67,1.396c2.302,0,3.859-1.329,3.859-3.179c0-1.783-1.265-2.886-3.665-3.858
		c-3.308-1.297-5.351-2.788-5.351-5.61c0-2.691,1.913-4.734,4.896-5.221v-3.275h2.011v3.146c1.945,0.064,3.274,0.584,4.216,1.135
		l-0.812,2.14c-0.681-0.39-2.01-1.103-4.086-1.103c-2.496,0-3.437,1.492-3.437,2.789c0,1.687,1.199,2.529,4.021,3.697
		c3.34,1.361,5.027,3.048,5.027,5.934c0,2.563-1.785,4.962-5.124,5.513v3.372H115.01z"
                />
            </g>
            <g>
                <path
                    fill={fill}
                    d="M98.965,50.556c-0.173,0-0.315-0.055-0.428-0.168c-0.112-0.111-0.169-0.254-0.169-0.428v-5.396H93.05
		c-0.173,0-0.315-0.056-0.428-0.169c-0.113-0.112-0.169-0.255-0.169-0.427v-0.831c0-0.173,0.056-0.315,0.169-0.428
		c0.112-0.112,0.255-0.169,0.428-0.169h5.318V37.3c0-0.173,0.057-0.315,0.169-0.428c0.112-0.113,0.255-0.169,0.428-0.169h0.909
		c0.172,0,0.314,0.056,0.427,0.169c0.112,0.112,0.169,0.255,0.169,0.428v5.24h5.345c0.173,0,0.315,0.057,0.428,0.169
		s0.169,0.255,0.169,0.428v0.831c0,0.172-0.057,0.314-0.169,0.427c-0.112,0.113-0.255,0.169-0.428,0.169h-5.345v5.396
		c0,0.174-0.057,0.316-0.169,0.428c-0.112,0.113-0.255,0.168-0.427,0.168H98.965z"
                />
            </g>
            <g>
                <path
                    fill={fill}
                    d="M64.686,44.994c-0.174,0-0.315-0.056-0.429-0.169c-0.112-0.111-0.168-0.255-0.168-0.428V42.53
		c0-0.173,0.056-0.316,0.168-0.43c0.113-0.111,0.255-0.168,0.429-0.168h1.868c0.172,0,0.319,0.057,0.439,0.168
		c0.122,0.113,0.183,0.257,0.183,0.43v1.867c0,0.173-0.061,0.316-0.183,0.428c-0.12,0.113-0.268,0.169-0.439,0.169H64.686z"
                />
                <path
                    fill={fill}
                    d="M71.223,44.994c-0.173,0-0.315-0.056-0.427-0.169c-0.114-0.111-0.17-0.255-0.17-0.428V42.53
		c0-0.173,0.056-0.316,0.17-0.43c0.111-0.111,0.254-0.168,0.427-0.168h1.868c0.172,0,0.32,0.057,0.441,0.168
		c0.12,0.113,0.181,0.257,0.181,0.43v1.867c0,0.173-0.061,0.316-0.181,0.428c-0.121,0.113-0.27,0.169-0.441,0.169H71.223z"
                />
                <path
                    fill={fill}
                    d="M77.761,44.994c-0.173,0-0.315-0.056-0.428-0.169c-0.113-0.111-0.17-0.255-0.17-0.428V42.53
		c0-0.173,0.057-0.316,0.17-0.43c0.112-0.111,0.255-0.168,0.428-0.168h1.868c0.173,0,0.319,0.057,0.44,0.168
		c0.121,0.113,0.182,0.257,0.182,0.43v1.867c0,0.173-0.061,0.316-0.182,0.428c-0.121,0.113-0.268,0.169-0.44,0.169H77.761z"
                />
            </g>
            <polygon
                fillRule="evenodd"
                clipRule="evenodd"
                fill={fill}
                points="73.491,3.419 79.91,3.419 76.701,8.978 73.491,14.536
	70.282,8.978 67.072,3.419 "
            />
        </svg>
    );
};

AvgPriceIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.number
};

export default AvgPriceIcon;
